import React from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';

const HomeCatList = ({ homecats, deleteHomeCat }) => {
  return (
    <div
      className='grid grid-cols-6 rounded-lg border p-2'
      data-cy='homecat-list-table'
    >
      <div className='col-span-3 border-b p-2 font-bold text-gray-500'>
        Name
      </div>
      <div className=' border-b p-2 font-bold text-gray-500 '>Last Login</div>
      <div className='border-b p-2 text-center font-bold text-gray-500 '>
        Active
      </div>
      <div className='p2 border-b'>&nbsp;</div>

      {homecats?.map((cat, index) => {
        return (
          <React.Fragment key={index}>
            <div className='catName col-span-3 p-2 '>{cat.admin_name}</div>
            <div className=' p-2'>
              {cat.admin_last_login ? cat.admin_last_login : '-'}
            </div>
            <div className='p-2 text-center'>YES</div>
            <div
              className='p2 flex items-center justify-center text-center'
              data-cy={`delete-button-${cat.admin_name}`}
            >
              <DeleteForeverIcon
                sx={{ cursor: 'pointer' }}
                id={`delete-button-${index}`}
                onClick={() => deleteHomeCat(cat.admin_id)}
              />
            </div>
          </React.Fragment>
        );
      })}

      {(homecats?.length === 0 || homecats === undefined) && (
        <div
          className='col-span-6 my-8 text-center font-bold text-gray-300'
          data-cy='no-acc-created-text'
        >
          No Home Cat Accounts created
        </div>
      )}
    </div>
  );
};

export default HomeCatList;
